// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__GZ-wE {
  background-color: #1a1a1a;
  color: #fff;
  padding: 20px 10px;
  text-align: center;
}

.Footer_container__urylt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.Footer_comboContainer__gL\\+fB {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.Footer_allLinksContainer__paXlE {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  width: 100%;
}

.Footer_logoSection__ttZLT {
  text-align: center;
}

.Footer_logoImage__gg4dY {
  height: 50px;
  width: auto;
}

.Footer_logo__\\+OD2R {
  font-size: 24px;
  font-weight: bold;
}

.Footer_linksSection__ooFRy {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  width: 100%;
}

.Footer_linkGroup__1MtD0 h3 {
  margin-bottom: 10px;
  font-size: 16px;
}

.Footer_linkGroup__1MtD0 ul {
  list-style: none;
  padding: 0;
}

.Footer_linkGroup__1MtD0 li {
  cursor: pointer;
  margin-bottom: 8px;
  transition: color 0.3s ease;
  color: #636363;
  font-size: 14px;
}

.Footer_linkGroup__1MtD0 li:hover {
  color: #ccc;
}

.Footer_socialSection__EaltQ {
  text-align: center;
}

.Footer_socialIcons__snYJY {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 10px 0;
}

.Footer_icon__wSlyc {
  width: 25px;
  height: 25px;
  color: #fff;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.3s ease;
}

.Footer_icon__wSlyc:hover {
  color: #ccc;
  transform: scale(1.1);
}

.Footer_support__GFYqt h3 {
  margin: 10px 0;
}

.Footer_support__GFYqt p {
  margin: 0;
  color: #636363;
  font-size: 14px;
}

.Footer_footerBottom__r6H7B {
  margin-top: 20px;
  border-top: 1px solid #333;
  padding-top: 10px;
}
.Footer_emailLink__uWWpz {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.Footer_emailLink__uWWpz:hover {
  text-decoration: underline;
}

/* Tablet and larger screens */
@media (min-width: 768px) {
  .Footer_container__urylt {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 40px;
  }

  .Footer_allLinksContainer__paXlE {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
  }

  .Footer_logoImage__gg4dY {
      height: 65px;
  }
}

/* Desktop screens */
@media (min-width: 1024px) {
  .Footer_container__urylt {
      padding: 0 40px;
  }

  .Footer_linksSection__ooFRy {
      gap: 100px;
  }

  .Footer_icon__wSlyc {
      width: 30px;
      height: 30px;
  }
}

/* Desktop screens */
@media (max-width: 480px) {
  .Footer_allLinksContainer__paXlE {
    gap: 0px !important;
  }
  .Footer_footerBottom__r6H7B {
   padding-top: 0px;
  }
  .Footer_container__urylt {
    display: block;
  }
  .Footer_footer__GZ-wE {
    padding: 20px 0 1px 0px;
    font-size: 0.8rem;
  }
  .Footer_logoImage__gg4dY {
    height: 37px;
  }
  .Footer_icon__wSlyc {
    height: 20px;
  }
  .Footer_linkGroup__1MtD0 li {
    margin-bottom: 3px;
  }
  .Footer_footerBottom__r6H7B {
    margin-top: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/common/UI/CSS/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE;MACI,mBAAmB;MACnB,mBAAmB;MACnB,8BAA8B;MAC9B,SAAS;EACb;;EAEA;MACI,mBAAmB;MACnB,8BAA8B;MAC9B,uBAAuB;EAC3B;;EAEA;MACI,YAAY;EAChB;AACF;;AAEA,oBAAoB;AACpB;EACE;MACI,eAAe;EACnB;;EAEA;MACI,UAAU;EACd;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,mBAAmB;EACrB;EACA;GACC,gBAAgB;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".footer {\n  background-color: #1a1a1a;\n  color: #fff;\n  padding: 20px 10px;\n  text-align: center;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.comboContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.allLinksContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  align-items: center;\n  width: 100%;\n}\n\n.logoSection {\n  text-align: center;\n}\n\n.logoImage {\n  height: 50px;\n  width: auto;\n}\n\n.logo {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.linksSection {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 40px;\n  width: 100%;\n}\n\n.linkGroup h3 {\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.linkGroup ul {\n  list-style: none;\n  padding: 0;\n}\n\n.linkGroup li {\n  cursor: pointer;\n  margin-bottom: 8px;\n  transition: color 0.3s ease;\n  color: #636363;\n  font-size: 14px;\n}\n\n.linkGroup li:hover {\n  color: #ccc;\n}\n\n.socialSection {\n  text-align: center;\n}\n\n.socialIcons {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin: 10px 0;\n}\n\n.icon {\n  width: 25px;\n  height: 25px;\n  color: #fff;\n  cursor: pointer;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.icon:hover {\n  color: #ccc;\n  transform: scale(1.1);\n}\n\n.support h3 {\n  margin: 10px 0;\n}\n\n.support p {\n  margin: 0;\n  color: #636363;\n  font-size: 14px;\n}\n\n.footerBottom {\n  margin-top: 20px;\n  border-top: 1px solid #333;\n  padding-top: 10px;\n}\n.emailLink {\n  color: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.emailLink:hover {\n  text-decoration: underline;\n}\n\n/* Tablet and larger screens */\n@media (min-width: 768px) {\n  .container {\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      gap: 40px;\n  }\n\n  .allLinksContainer {\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: flex-start;\n  }\n\n  .logoImage {\n      height: 65px;\n  }\n}\n\n/* Desktop screens */\n@media (min-width: 1024px) {\n  .container {\n      padding: 0 40px;\n  }\n\n  .linksSection {\n      gap: 100px;\n  }\n\n  .icon {\n      width: 30px;\n      height: 30px;\n  }\n}\n\n/* Desktop screens */\n@media (max-width: 480px) {\n  .allLinksContainer {\n    gap: 0px !important;\n  }\n  .footerBottom {\n   padding-top: 0px;\n  }\n  .container {\n    display: block;\n  }\n  .footer {\n    padding: 20px 0 1px 0px;\n    font-size: 0.8rem;\n  }\n  .logoImage {\n    height: 37px;\n  }\n  .icon {\n    height: 20px;\n  }\n  .linkGroup li {\n    margin-bottom: 3px;\n  }\n  .footerBottom {\n    margin-top: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__GZ-wE`,
	"container": `Footer_container__urylt`,
	"comboContainer": `Footer_comboContainer__gL+fB`,
	"allLinksContainer": `Footer_allLinksContainer__paXlE`,
	"logoSection": `Footer_logoSection__ttZLT`,
	"logoImage": `Footer_logoImage__gg4dY`,
	"logo": `Footer_logo__+OD2R`,
	"linksSection": `Footer_linksSection__ooFRy`,
	"linkGroup": `Footer_linkGroup__1MtD0`,
	"socialSection": `Footer_socialSection__EaltQ`,
	"socialIcons": `Footer_socialIcons__snYJY`,
	"icon": `Footer_icon__wSlyc`,
	"support": `Footer_support__GFYqt`,
	"footerBottom": `Footer_footerBottom__r6H7B`,
	"emailLink": `Footer_emailLink__uWWpz`
};
export default ___CSS_LOADER_EXPORT___;
